import mapTypes from "./map.types";

export const SetMap = map => ({
    type: mapTypes.SET_MAP,
    payload: map
});
export const SetIconsLayer = layer => ({
    type: mapTypes.ICONS_LAYER,
    payload: layer
});
export const AddReportLayer = newLayer => ({
    type: mapTypes.ADD_REPORT_LAYER,
    payload: newLayer
});
export const SetTimer = timer => ({
    type: mapTypes.SET_TIMER,
    payload: timer
});
export const SetMountLiveTime = time => ({
    type: mapTypes.SET_MOUNT_LIVE_TIME,
    payload: time
});
export const SetRefresher = refresher => ({
    type: mapTypes.SET_REFRESHER,
    payload: refresher
});
export const RefreshRefresher = time => ({
    type: mapTypes.REFRESH_REFRESHER,
    payload: time
});
export const SetMainRefresherTimer = sec => ({
    type: mapTypes.CHOOSE_MAIN_REFRESHER,
    payload: sec
});
export const SetCounterLiveShowTime = liveTime => ({
    type: mapTypes.REFRESH_COUNTER,
    payload: liveTime
});
export const SetLivePath = livePath => ({
    type: mapTypes.SET_LIVE_PATH,
    payload: livePath
});